<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/rest-hours-management/vessel-holiday-calendars"></back-button>
          Add Vessel Holiday Calendar
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Rest Hours Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/rest-hours-management/vessel-holiday-calendars`"
              >Vessel Holiday Calendars</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Vessel</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.vessel_id"
                  :suggestions="vessels"
                  placeholder="Select vessel"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label"
                >Holiday Calendar Nama</label
              >
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.holiday_calendar_id"
                  :suggestions="holiday_calendars"
                  placeholder="Select holiday calendar name"
                ></my-select>
              </div>
            </div>

            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";

export default {
  name: "Vessel Holiday CalendarCreate",
  data() {
    return {
      form: {
        vessel_id: "",
        holiday_calendar_id: "",
      },
      vessels: [],
      holiday_calendars: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("vessel_holiday_calendars/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.holiday_calendars.forEach((holiday_calender) => {
        this.holiday_calendars.push({
          id: holiday_calender.id,
          name: holiday_calender.name,
        });
      });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/vessel_holiday_calendars", this.form);
        this.isLoading = false;
        this.$router.push("/rest-hours-management/vessel-holiday-calendars");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
